/** Entity a new flight is logged under unless the operator is set otherwise. Shared with the web app. */
export const DEFAULT_OPERATOR = 'Shock Strategy Group, LLC';
